import React from 'react';

import { DescriptionList, DescriptionItem } from '@gogame/components';

const DynamicReward = ({ data, showAdditionalReward }) => {
  return (
    <DescriptionList disableGutters data={data}>
      <DescriptionItem
        label={'Platforms'}
        field={'platforms'}
        valueParser={'commaList'}
      />
      <DescriptionItem
        label={'Dynamic reward package'}
        field={'dynamicReward'}
        valueParser={(v) => v.join(', ')}
      />
      {showAdditionalReward ? (
        <DescriptionItem
          label={'Ad. dynamic reward packages'}
          field={'dynamicAdditionalRewards'}
          listType={'bullet'}
          type={'typographyList'}
          getLabel={({ additionalPackage, additionalCondition }) => {
            return `${additionalPackage} (${additionalCondition})`;
          }}
        />
      ) : null}
    </DescriptionList>
  );
};

export default DynamicReward;
